export const sagaActions = {
  START_FETCH_LIST_ALL_REQUESTS: "START_FETCH_LIST_ALL_REQUESTS",
  START_SEARCH_LIST_ALL_REQUESTS: "START_SEARCH_LIST_ALL_REQUESTS",
  START_FETCH_LIST_OWN_REQUESTS: "START_FETCH_LIST_OWN_REQUESTS",
  START_SEARCH_LIST_OWN_REQUESTS: "START_SEARCH_LIST_OWN_REQUESTS",
  START_SEARCH_LIST_HISTORY_REQUESTS: "START_SEARCH_LIST_HISTORY_REQUESTS",
  START_FETCH_LIST_HISTORY_REQUESTS: "START_FETCH_LIST_HISTORY_REQUESTS",
  START_FETCH_LIST_PARTICIPANTS_REQUESTS:
    "START_FETCH_LIST_PARTICIPANTS_REQUESTS",
  START_SEARCH_LIST_PARTICIPANTS_REQUESTS:
    "START_SEARCH_LIST_PARTICIPANTS_REQUESTS",
  START_FETCH_LIST_WORKFLOW_CONFIGURATION:
    "START_FETCH_LIST_WORKFLOW_CONFIGURATION",
  START_SEARCH_LIST_WORKFLOW_CONFIGURATION:
    "START_SEARCH_LIST_WORKFLOW_CONFIGURATION",
};
